// extracted by mini-css-extract-plugin
export default {"markdown-content-scope":"changelog_markdown-content-scope__hxJGf"};